import { Card } from "react-bootstrap";

export default function  SetupVideo() {
  const resources = [
    {
      title: "Teaching Center: Guide to equipment",
      description: "Make a home studio on a budget",
      link: "#",
    },
    {
      title: "KaaS Trust & Safety",
      description: "Our policies for instructors and students",
      link: "#",
    },
    {
      title: "Join the community",
      description:
        "A place to talk with other instructors",
      link: "#",
    },
  ];
  return (
    <div className="p-4">
      <h2 className="mb-4">Setup & test video</h2>

      <div className="d-flex gap-5">
        <div className="flex-grow-1">
          <div className="mb-5">
            <h3 className="h4 mb-3">Arrange your ideal studio and get early feedback</h3>
            <p className="text-muted">
              It's important to get your audio and video set up correctly now, because it's much more difficult to fix
              your videos after you've recorded. There are many creative ways to use what you have to create
              professional looking video.
            </p>
          </div>

          <div className="mb-5">
            <h3 className="h4 mb-4">Tips</h3>

            <div className="mb-4">
              <h4 className="h5 mb-2">Equipment can be easy.</h4>
              <p className="text-muted">
                You don't need to buy fancy equipment. Most smartphone cameras can capture video in HD, and you can
                record audio on another phone or external microphone.
              </p>
            </div>

            <div className="mb-4">
              <h4 className="h5 mb-2">Students need to hear you.</h4>
              <p className="text-muted">
                A good microphone is the most important piece of equipment you will choose. There are lot of affordable
                options. Make sure it's correctly plugged in and 6-12 inches (15-30 cm) from you.
              </p>
            </div>

            <div>
              <h4 className="h5 mb-2">Make a studio.</h4>
              <p className="text-muted">
                Find a quiet place to film with good lighting and a simple background. Natural light from windows works
                great, just make sure it's not behind you.
              </p>
            </div>
            <div>
              <h4 className="h5 mb-2">Light the scene and your face.</h4>
              <p className="text-muted">
              Turn off overhead lights. Experiment with three point lighting by placing two lamps in front of you and one behind aimed on the background.
              </p>
            </div>
            <div>
              <h4 className="h5 mb-2">Reduce noise and echo.</h4>
              <p className="text-muted">
              Turn off fans or air vents, and record at a time when it’s quiet. Place acoustic foam or blankets on the walls, and bring in rugs or furniture to dampen echo.
              </p>
            </div>
            <div>
              <h4 className="h5 mb-2">Be creative.</h4>
              <p className="text-muted">
              Students won’t see behind the scenes. No one will know if you’re surrounded by pillows for soundproofing...unless you tell other instructors in the community!
              </p>
            </div>
          </div>
          <div className="container mt-4">
            <h4 className="fw-bold">Requirements</h4>
            <ul className="list-unstyled">
              <li>🔹Film and export in HD to create videos of at least 720p, or 1080p if possible</li>
              <li>🔹 Audio should come out of both the left and right channels and be synced to your video</li>
              <li>🔹Audio should be free of echo and background noise so as not to be distracting to students</li>
            </ul>
          </div>
          <div className="container mt-4">
            <h4 className="fw-bold">Resources</h4>
            {resources.map((resource, index) => (
              <div key={index} className="mb-3">
                <a
                  href={resource.link}
                  className="text-primary fw-bold text-decoration-underline"
                >
                  {resource.title}
                </a>
                <p className="m-0">{resource.description}</p>
              </div>
            ))}
          </div>
        </div>

        <Card className="bg-white shadow-sm" style={{ maxWidth: "300px" }}>
          <Card.Body className="text-center">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-Sg2z7mW3IV7OY1AaWSMunFYif4IT8r.png"
              alt="Video camera illustration"
              className="mb-3"
              style={{ width: "100px", height: "auto" }}
            />
            <h4 className="h5 mb-3">Free expert video help</h4>
            <p className="text-muted mb-4">Get personalized advice on your audio and video</p>
            <button className="btn btn-outline-primary">Create a test video</button>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
